import { render, staticRenderFns } from "./ContactoData.vue?vue&type=template&id=aefb259a"
import script from "./ContactoData.vue?vue&type=script&lang=js"
export * from "./ContactoData.vue?vue&type=script&lang=js"
import style0 from "./ContactoData.vue?vue&type=style&index=0&id=aefb259a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports